import { useEffect } from 'react';
// Fix: Use namespace import for react-router-dom to avoid missing exported member errors
import * as ReactRouterDOM from 'react-router-dom';

const { useLocation } = ReactRouterDOM as any;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll au sommet de la page avec un comportement fluide ou instantané
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;